export default "__VITE_ASSET__Dovkw1nm__"